import { fetchProficienciesProgress, fetchProficienciesProgressGroups } from "../services/proficienciesService";
import { ProficiencyProgress } from "../types/proficiencies";
import { usePublicData } from "./usePublicData";

export type ProgressByGroup = Record<string, ProficiencyProgress[]>;

export default function usePilotProficiencyProgress(pilotUid: string | null) {
  return usePublicData<ProgressByGroup | null>(`proficiency-progress:${pilotUid ?? ""}`, async () => {
    if (!pilotUid) return null;
    const { groups } = await fetchProficienciesProgressGroups({ pilotUid });
    const entries = await Promise.all(groups.map(async group => {
      const response = await fetchProficienciesProgress({ pilotUid, group });
      return [group, response.proficiencies] as const;
    }));
    return Object.fromEntries(entries);
  });
}
